
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
:host{--lds-ring-color:var(--brand-primary)}.wrapper{display:flex;gap:var(--gap-4lg)}.lds-ring{display:inline-block;height:80px;position:relative;width:80px}.entity{width:100%}.lds-ring div{animation:lds-ring 1.2s cubic-bezier(.5,0,.5,1) infinite;border:8px solid var(--lds-ring-color);border-color:var(--lds-ring-color) transparent transparent transparent;border-radius:var(--br-base);box-sizing:border-box;display:block;height:64px;margin:8px;position:absolute;width:64px}.lds-ring div:first-child{animation-delay:-.45s}.lds-ring div:nth-child(2){animation-delay:-.3s}.lds-ring div:nth-child(3){animation-delay:-.15s}@keyframes lds-ring{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}`;